/* tsg-wizard.js — Fix My Spa full diagnostic wizard */
(function () {
  'use strict';

  /* ── DATA ──────────────────────────────────────────────────── */
  var SYMPTOMS = [
    { id: 'not-heating',   label: 'Not heating',           hint: 'Heater element / sensor',   svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2c0 6-8 6-8 12a8 8 0 0 0 16 0c0-6-8-6-8-12z"/><line x1="2" y1="2" x2="22" y2="22"/></svg>' },
    { id: 'pump-fault',    label: 'Pump noise or fault',   hint: 'Pump / motor / seals',      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"/></svg>' },
    { id: 'error-code',    label: 'Error code showing',    hint: 'Circuit board / sensor',    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' },
    { id: 'water-quality', label: 'Cloudy or smelly water', hint: 'Filter / chemicals',       svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/><line x1="2" y1="2" x2="22" y2="22"/></svg>' },
    { id: 'jets-failing',  label: 'Jets not working',      hint: 'Jet bodies / air lock',     svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/><line x1="21.17" y1="8" x2="12" y2="8"/><line x1="3.95" y1="6.06" x2="8.54" y2="14"/><line x1="10.88" y1="21.94" x2="15.46" y2="14"/></svg>' },
    { id: 'control-dead',  label: 'Control panel dead',    hint: 'PCB / topside panel',       svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' }
  ];

  var BRANDS = [
    { id: 'spanet',   label: 'Spanet' },
    { id: 'balboa',   label: 'Balboa' },
    { id: 'gecko',    label: 'Gecko' },
    { id: 'edgetec',  label: 'Edgetec' },
    { id: 'davey',    label: 'Davey' },
    { id: 'hotspring',label: 'Hot Spring' },
    { id: 'mspa',     label: 'MSPA' },
    { id: 'other',    label: 'Other / Not sure' }
  ];

  var MODELS = {
    spanet:    [ 'VS501', 'VS510 / VX510', 'SP1200', 'BP601S', 'SV Series', 'Not sure' ],
    balboa:    [ 'GS501Z / GS501SZ', 'GS510DZ', 'BP501 / BP601', 'VS501Z / VS501SZ', 'M7 Tech', 'BP100 / BP200', 'Not sure' ],
    gecko:     [ 'IN.YE-3', 'IN.YT-3', 'IN.K600', 'IN.XE', 'IN.STREAM', 'Not sure' ],
    edgetec:   [ 'SD7', 'SD11', 'GL2000', 'BT100', 'Not sure' ],
    davey:     [ 'Spa-Quip SP400', 'Spa-Quip SP600', 'Spa-Net branded', 'Not sure' ],
    hotspring: [ 'Highlife Collection', 'Limelight Collection', 'Hot Spot Collection', 'Jetsetter', 'Not sure' ],
    mspa:      [ 'Alpine', 'Exotic', 'Frame', 'Not sure' ],
    other:     [ 'Not sure — help me identify it' ]
  };

  /* parts: symptom → brand → model → [{name, url, confidence, note}] */
  var PARTS = {
    'not-heating': {
      spanet: {
        _default: [
          { name: 'Spanet Heater Element (3kW)', url: '/collections/heater-elements', confidence: 'high', note: 'Most common cause of no-heat on Spanet systems. Check the element first — we stock titanium and standard elements.' },
          { name: 'Spanet Temperature Sensor', url: '/collections/sensors', confidence: 'likely', note: 'A faulty temp sensor can report incorrect water temperature, causing the heater to shut down.' }
        ],
        'VS510 / VX510': [
          { name: 'Spanet VS510 Heater Element 3kW', url: '/collections/heater-elements', confidence: 'high', note: 'Most common fault on VS510/VX510. Replace the element first — 90% of no-heat cases on this model.' },
          { name: 'Spanet VS510 Temp Sensor', url: '/collections/sensors', confidence: 'likely', note: 'If the element tests OK (continuity check), replace the temperature sensor next.' },
          { name: 'Spanet VS510 Hi-Limit Sensor', url: '/collections/sensors', confidence: 'possible', note: 'A tripped hi-limit will prevent heating. Reset it first — if it keeps tripping, replace it.' }
        ]
      },
      balboa: {
        _default: [
          { name: 'Balboa 3kW Heater Element', url: '/collections/heater-elements', confidence: 'high', note: 'Standard Balboa heater element. Fits most GS and BP series controllers.' },
          { name: 'Balboa Pressure / Flow Switch', url: '/collections/sensors', confidence: 'likely', note: 'A failed pressure switch prevents the heater from firing — spa thinks there\'s no water flow.' },
          { name: 'Balboa Hi-Limit Sensor', url: '/collections/sensors', confidence: 'possible', note: 'Hi-limit sensors trip on Balboa systems and can cause a no-heat FL or OH fault code.' }
        ],
        'GS501Z / GS501SZ': [
          { name: 'Balboa GS501Z Heater Element 3kW', url: '/collections/heater-elements', confidence: 'high', note: 'The 3kW element is the most common GS501Z no-heat fault. Test it with a multimeter (should read ~18 ohms) before ordering.' },
          { name: 'Balboa GS501Z Pressure Switch', url: '/collections/sensors', confidence: 'high', note: 'The pressure switch on GS501Z fails frequently. If you\'re getting a FL1 or OH code with no heat, this is likely.' },
          { name: 'Balboa GS501Z Hi-Limit Sensor', url: '/collections/sensors', confidence: 'likely', note: 'Sensor replacement kit for the GS501Z temperature / hi-limit assembly.' }
        ]
      },
      gecko: {
        _default: [
          { name: 'Gecko 3kW Heater Element', url: '/collections/heater-elements', confidence: 'high', note: 'Standard Gecko heater element. Fits IN.YE and IN.YT series controllers.' },
          { name: 'Gecko Flow Switch', url: '/collections/sensors', confidence: 'likely', note: 'Gecko flow switches fail and present as a no-heat / FLO error.' }
        ]
      },
      edgetec: {
        _default: [
          { name: 'Edgetec / Spanet 3kW Heater Element', url: '/collections/heater-elements', confidence: 'high', note: 'Edgetec controllers often use Spanet-compatible heater elements.' },
          { name: 'Temperature Sensor', url: '/collections/sensors', confidence: 'likely', note: 'Check the sensor with a multimeter — resistance should change with water temperature.' }
        ]
      },
      davey: {
        _default: [
          { name: 'Davey / Spa-Quip Heater Element', url: '/collections/heater-elements', confidence: 'high', note: 'Davey spa heater element — confirm your kW rating before ordering.' },
          { name: 'Thermostat / Hi-Limit', url: '/collections/sensors', confidence: 'likely', note: 'Davey systems use a combined thermostat/hi-limit that fails over time.' }
        ]
      },
      _default: {
        _default: [
          { name: 'Universal Heater Element (2kW–6kW)', url: '/collections/heater-elements', confidence: 'likely', note: 'We stock heater elements for all major brands. Check your existing element for kW rating and flange size before ordering, or use our free Parts Finder.' }
        ]
      }
    },
    'pump-fault': {
      spanet: {
        _default: [
          { name: 'Spanet Pump Wet End', url: '/collections/pump-parts', confidence: 'high', note: 'If the motor runs but produces no water flow, the wet end impeller is the likely fault.' },
          { name: 'Pump Shaft Seal Kit', url: '/collections/pump-parts', confidence: 'high', note: 'Leaking water from the pump body almost always means a failed shaft seal.' },
          { name: 'Capacitor (Start / Run)', url: '/collections/electrical-components', confidence: 'likely', note: 'A humming pump that won\'t start typically has a failed capacitor — a cheap easy fix.' }
        ]
      },
      balboa: {
        _default: [
          { name: 'Balboa Circulation Pump', url: '/collections/circulation-pumps-1', confidence: 'high', note: 'Balboa GS systems use a separate circulation pump. If heating is also affected, this is likely.' },
          { name: 'Pump Wet End (1hp / 2hp)', url: '/collections/pump-parts', confidence: 'high', note: 'Jet pump wet end — choose the correct HP rating for your spa.' },
          { name: 'Pump Capacitor', url: '/collections/electrical-components', confidence: 'likely', note: 'Capacitor failure is one of the most common pump faults — hum but no spin.' }
        ]
      },
      _default: {
        _default: [
          { name: 'Pump Shaft Seal Kit', url: '/collections/pump-parts', confidence: 'high', note: 'Leaking from the pump shaft is a seal failure. We stock seals for all major pump brands.' },
          { name: 'Pump Capacitor', url: '/collections/electrical-components', confidence: 'high', note: 'Pump won\'t start but hums? Almost always a capacitor. Cheap fix — typically under $30.' },
          { name: 'Pump Wet End', url: '/collections/pump-parts', confidence: 'likely', note: 'If the motor runs but produces no pressure or flow, the impeller / wet end is damaged.' }
        ]
      }
    },
    'error-code': {
      _brand_default: {
        _default: [
          { name: 'View NZ Spa Error Codes Library', url: '/pages/spa-error-codes', confidence: 'high', note: 'Our full library covers every error code for Spanet, Balboa, Gecko, Edgetec and Davey — with plain-English explanations and the part to fix it.' }
        ]
      },
      spanet: {
        _default: [
          { name: 'View Spanet Error Codes', url: '/pages/spa-error-codes', confidence: 'high', note: 'Common Spanet codes: OH (over heat — check flow), LOC (keypad lock), SF (sensor fault). Our library explains every code.' },
          { name: 'Spanet Temperature Sensor', url: '/collections/sensors', confidence: 'likely', note: 'Sensor fault codes (SF, SN, S1/S2) almost always mean a failed temperature sensor.' },
          { name: 'Spanet PCB / Control Board', url: '/collections/circuit-boards', confidence: 'possible', note: 'If sensors test OK and the code persists, a control board fault is possible.' }
        ]
      },
      balboa: {
        _default: [
          { name: 'View Balboa Error Codes', url: '/pages/spa-error-codes', confidence: 'high', note: 'Common Balboa codes: FL1 (flow fault — check pressure switch), OH (overheat), dr (sensor). Our library explains all.' },
          { name: 'Balboa Pressure Switch', url: '/collections/sensors', confidence: 'likely', note: 'FL1 / FLC codes on Balboa = failed pressure switch almost every time.' },
          { name: 'Balboa GS501Z Circuit Board', url: '/collections/circuit-boards', confidence: 'possible', note: 'If the code is persistent and components test OK, a board replacement may be needed.' }
        ]
      },
      gecko: {
        _default: [
          { name: 'View Gecko Error Codes', url: '/pages/spa-error-codes', confidence: 'high', note: 'Gecko codes: FLO (flow fault), Sn1/Sn3 (sensor), OH (overheat). Our library covers all IN.YE and IN.YT codes.' },
          { name: 'Gecko Flow Switch', url: '/collections/sensors', confidence: 'likely', note: 'FLO code on Gecko = flow switch failure in most cases.' }
        ]
      },
      _default: {
        _default: [
          { name: 'View Full Error Codes Library', url: '/pages/spa-error-codes', confidence: 'high', note: 'Every error code for every brand, explained in plain English. Find your code and the part to fix it.' }
        ]
      }
    },
    'water-quality': {
      _default: {
        _default: [
          { name: 'Replacement Filter Cartridge', url: '/collections/replacement-cartridges', confidence: 'high', note: 'Cloudy water almost always starts with a dirty or exhausted filter. Replace it before adding more chemicals.' },
          { name: 'Spa Clarifier', url: '/collections/spa-chemicals', confidence: 'high', note: 'A clarifier binds fine particles so the filter can capture them. Fast fix for milky water.' },
          { name: 'Spa Water Test Kit', url: '/collections/water-testing', confidence: 'high', note: 'Test your pH, alkalinity, and sanitiser levels first — imbalanced chemistry is the root cause of most water quality issues.' },
          { name: 'Spa Chemical Starter Kit', url: '/collections/spa-chemicals', confidence: 'likely', note: 'If water chemistry is off, a full rebalance kit gets you back on track fast.' }
        ]
      }
    },
    'jets-failing': {
      _default: {
        _default: [
          { name: 'Jet Bodies (all styles)', url: '/collections/spa-jets', confidence: 'high', note: 'Cracked or seized jet bodies are the most common cause of non-functioning jets. We stock all styles and sizes.' },
          { name: 'Air Injectors', url: '/collections/air-injectors', confidence: 'likely', note: 'Air injectors block with calcium and scale over time — cleaning or replacement fixes weak jets.' },
          { name: 'Pump Wet End / Impeller', url: '/collections/pump-parts', confidence: 'likely', note: 'If multiple jets are weak simultaneously, the pump impeller may be damaged or clogged.' },
          { name: 'Check Valve', url: '/collections/plastic-parts-unions', confidence: 'possible', note: 'A faulty check valve lets air back into the system, creating air locks that kill jet pressure.' }
        ]
      }
    },
    'control-dead': {
      spanet: {
        _default: [
          { name: 'Spanet Topside / Touch Pad', url: '/collections/touch-pads', confidence: 'high', note: 'The topside panel is the most common failure point on Spanet systems — usually before the board fails.' },
          { name: 'Spanet PCB / Control Board', url: '/collections/circuit-boards', confidence: 'likely', note: 'If the topside tests OK and the board has no LED activity, a board replacement is needed.' },
          { name: 'Fuse (30A)', url: '/collections/electrical-components', confidence: 'high', note: 'Check the fuses on the board first — a completely dead panel is often just a blown fuse.' }
        ],
        'VS510 / VX510': [
          { name: 'Spanet VS510 Topside Panel', url: '/collections/touch-pads', confidence: 'high', note: 'The VS510 topside is a common failure. Test by unplugging and replugging the ribbon cable first.' },
          { name: 'Spanet VS510 Main PCB', url: '/collections/circuit-boards', confidence: 'likely', note: 'We stock VS510 main boards. Call us to confirm your exact board revision before ordering.' },
          { name: 'Fuse Kit', url: '/collections/electrical-components', confidence: 'high', note: 'VS510 boards have ATC fuses — check these before replacing any major components.' }
        ]
      },
      balboa: {
        _default: [
          { name: 'Balboa Topside / Touch Pad', url: '/collections/touch-pads', confidence: 'high', note: 'Balboa topsides fail regularly, especially when exposed to UV or moisture ingress.' },
          { name: 'Balboa GS501Z Circuit Board', url: '/collections/circuit-boards', confidence: 'likely', note: 'If the topside is OK but the board is completely unresponsive, a board swap is needed.' },
          { name: 'Balboa BP100 Replacement Board', url: '/collections/circuit-boards', confidence: 'possible', note: 'Older Balboa systems can often be upgraded to a newer compatible board — call us to confirm.' }
        ],
        'GS501Z / GS501SZ': [
          { name: 'Balboa GS501Z Topside Panel', url: '/collections/touch-pads', confidence: 'high', note: 'The GS501Z topside is a known failure point. We stock genuine replacements.' },
          { name: 'Balboa GS501Z Control Board', url: '/collections/circuit-boards', confidence: 'likely', note: 'We stock GS501Z boards. Check all fuses first — boards are expensive and fuses are often the real culprit.' }
        ]
      },
      gecko: {
        _default: [
          { name: 'Gecko IN.K Topside Panel', url: '/collections/touch-pads', confidence: 'high', note: 'Gecko topsides use proprietary connectors — confirm your model before ordering.' },
          { name: 'Gecko IN.YE Control Pack', url: '/collections/circuit-boards', confidence: 'likely', note: 'Full Gecko control pack replacement if the board is dead beyond repair.' }
        ]
      },
      edgetec: {
        _default: [
          { name: 'Edgetec Topside Panel', url: '/collections/touch-pads', confidence: 'high', note: 'Edgetec (SD7/SD11) topsides are available. Confirm your model number before ordering.' },
          { name: 'Edgetec SD7 Control Board', url: '/collections/circuit-boards', confidence: 'likely', note: 'SD7 and SD11 boards in stock. Check fuses on the board first.' }
        ]
      },
      _default: {
        _default: [
          { name: 'Spa Fuse Kit', url: '/collections/electrical-components', confidence: 'high', note: 'Always check fuses first — a completely dead panel is often just a blown 30A fuse. Cheap and easy.' },
          { name: 'Topside / Touch Pad (all brands)', url: '/collections/touch-pads', confidence: 'likely', note: 'We stock topsides for all major brands. Confirm your brand and model for the right fit.' },
          { name: 'Circuit Board / PCB', url: '/collections/circuit-boards', confidence: 'possible', note: 'Last resort after checking fuses and topside. Call us to confirm compatibility before ordering.' }
        ]
      }
    }
  };

  /* ── HELPERS ─────────────────────────────────────────────── */
  function getParts(symptomId, brandId, modelLabel) {
    var symptomData = PARTS[symptomId];
    if (!symptomData) return PARTS['water-quality']['_default']['_default'];

    /* error-code uses _brand_default as root fallback */
    var brandData = symptomData[brandId] || symptomData['_brand_default'] || symptomData['_default'];
    if (!brandData) return [];

    /* try exact model match */
    var modelData = brandData[modelLabel] || brandData['_default'];
    return modelData || [];
  }

  function confidenceBadge(c) {
    var map = { high: ['High confidence', 'tsg-wz-badge--high'], likely: ['Likely fix', 'tsg-wz-badge--likely'], possible: ['Possible cause', 'tsg-wz-badge--possible'] };
    var v = map[c] || map['possible'];
    return '<span class="tsg-wz-badge ' + v[1] + '">' + v[0] + '</span>';
  }

  /* ── STATE ───────────────────────────────────────────────── */
  var state = { step: 1, symptom: null, brand: null, model: null };

  /* ── RENDER ──────────────────────────────────────────────── */
  function render(root) {
    if (!root) return;
    var html = '';

    /* Progress bar */
    var pct = ((state.step - 1) / 3) * 100;
    html += '<div class="tsg-wz-progress" role="progressbar" aria-valuenow="' + state.step + '" aria-valuemin="1" aria-valuemax="4">';
    html += '<div class="tsg-wz-progress__bar" style="width:' + pct + '%"></div></div>';

    /* Step labels */
    html += '<div class="tsg-wz-steps">';
    var stepLabels = ['Symptom', 'Brand', 'Model', 'Your Fix'];
    for (var i = 0; i < 4; i++) {
      var cls = 'tsg-wz-step-label';
      if (i + 1 === state.step) cls += ' is-active';
      if (i + 1 < state.step) cls += ' is-done';
      html += '<div class="' + cls + '"><span class="tsg-wz-step-num">' + (i + 1) + '</span>' + stepLabels[i] + '</div>';
    }
    html += '</div>';

    if (state.step === 1) html += renderStep1();
    if (state.step === 2) html += renderStep2();
    if (state.step === 3) html += renderStep3();
    if (state.step === 4) html += renderStep4();

    /* Always-visible Parts Finder escape hatch */
    html += '<div class="tsg-wz-escape">Not getting the right answer? <a href="/pages/parts" class="tsg-wz-escape__link">Use our free Parts Finder service</a> — send us your spa details and we\'ll identify the exact part.</div>';

    root.innerHTML = html;
    bindEvents(root);
  }

  function renderStep1() {
    var h = '<div class="tsg-wz-content"><h2 class="tsg-wz-q">What\'s the problem with your spa?</h2><div class="tsg-wz-grid tsg-wz-grid--symptoms">';
    SYMPTOMS.forEach(function (s) {
      h += '<button class="tsg-wz-card" data-action="symptom" data-value="' + s.id + '" aria-label="Symptom: ' + s.label + '">';
      h += '<span class="tsg-wz-card__icon">' + s.svg + '</span>';
      h += '<span class="tsg-wz-card__label">' + s.label + '</span>';
      h += '<span class="tsg-wz-card__hint">' + s.hint + '</span>';
      h += '</button>';
    });
    h += '</div></div>';
    return h;
  }

  function renderStep2() {
    var symptomLabel = SYMPTOMS.find(function (s) { return s.id === state.symptom; }).label;
    var h = '<div class="tsg-wz-content">';
    h += '<button class="tsg-wz-back" data-action="back" aria-label="Go back">&#8592; Back</button>';
    h += '<h2 class="tsg-wz-q">What brand is your spa?</h2>';
    h += '<p class="tsg-wz-sub">Problem: <strong>' + symptomLabel + '</strong></p>';
    h += '<div class="tsg-wz-grid tsg-wz-grid--brands">';
    BRANDS.forEach(function (b) {
      h += '<button class="tsg-wz-brand-btn" data-action="brand" data-value="' + b.id + '">' + b.label + '</button>';
    });
    h += '</div></div>';
    return h;
  }

  function renderStep3() {
    var models = MODELS[state.brand] || ['Not sure'];
    var brandLabel = BRANDS.find(function (b) { return b.id === state.brand; }).label;
    var symptomLabel = SYMPTOMS.find(function (s) { return s.id === state.symptom; }).label;
    var h = '<div class="tsg-wz-content">';
    h += '<button class="tsg-wz-back" data-action="back" aria-label="Go back">&#8592; Back</button>';
    h += '<h2 class="tsg-wz-q">What model is your spa?</h2>';
    h += '<p class="tsg-wz-sub">' + brandLabel + ' &mdash; ' + symptomLabel + '</p>';
    h += '<div class="tsg-wz-grid tsg-wz-grid--models">';
    models.forEach(function (m) {
      h += '<button class="tsg-wz-model-btn" data-action="model" data-value="' + m + '">' + m + '</button>';
    });
    h += '</div></div>';
    return h;
  }

  function renderStep4() {
    var parts = getParts(state.symptom, state.brand, state.model);
    var brandLabel = BRANDS.find(function (b) { return b.id === state.brand; }).label;
    var symptomLabel = SYMPTOMS.find(function (s) { return s.id === state.symptom; }).label;
    var h = '<div class="tsg-wz-content">';
    h += '<button class="tsg-wz-back" data-action="back" aria-label="Go back">&#8592; Back</button>';
    h += '<div class="tsg-wz-result-header">';
    h += '<div class="tsg-wz-result-eyebrow">Diagnosis for your spa</div>';
    h += '<h2 class="tsg-wz-q">' + brandLabel + ' &mdash; ' + symptomLabel + '</h2>';
    if (state.model && state.model !== 'Not sure' && state.model !== 'Not sure — help me identify it') {
      h += '<p class="tsg-wz-sub">Model: ' + state.model + '</p>';
    }
    h += '</div>';

    if (!parts || parts.length === 0) {
      h += '<div class="tsg-wz-no-result"><p>We don\'t have a specific match for this combination yet — use our free Parts Finder and we\'ll identify the exact part for you.</p><a href="/pages/parts" class="tsg-wz-cta-btn">Free Parts Finder</a></div>';
    } else {
      h += '<div class="tsg-wz-parts">';
      parts.forEach(function (p, i) {
        h += '<div class="tsg-wz-part' + (i === 0 ? ' tsg-wz-part--primary' : '') + '">';
        if (i === 0) h += '<div class="tsg-wz-part__top-label">Most likely fix</div>';
        h += '<div class="tsg-wz-part__inner">';
        h += '<div class="tsg-wz-part__name">' + p.name + '</div>';
        h += confidenceBadge(p.confidence);
        h += '<p class="tsg-wz-part__note">' + p.note + '</p>';
        h += '<a href="' + p.url + '" class="tsg-wz-part__btn">Shop this part</a>';
        h += '</div></div>';
      });
      h += '</div>';
      h += '<div class="tsg-wz-actions">';
      h += '<a href="/pages/parts" class="tsg-wz-secondary-btn">Not right? Use Parts Finder</a>';
      h += '<button class="tsg-wz-restart" data-action="restart">Start over</button>';
      h += '</div>';
    }
    h += '</div>';
    return h;
  }

  /* ── EVENTS ──────────────────────────────────────────────── */
  function bindEvents(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.dataset.action;
      var value  = btn.dataset.value;

      if (action === 'symptom') { state.symptom = value; state.step = 2; }
      if (action === 'brand')   { state.brand   = value; state.step = 3; }
      if (action === 'model')   { state.model   = value; state.step = 4; }
      if (action === 'back')    { state.step = Math.max(1, state.step - 1); }
      if (action === 'restart') { state = { step: 1, symptom: null, brand: null, model: null }; }

      render(root);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── INIT ────────────────────────────────────────────────── */
  function init() {
    var roots = document.querySelectorAll('[data-tsg-wizard]');
    roots.forEach(function (root) {
      /* Check for pre-selected symptom (from homepage panel click) */
      var preselect = root.dataset.tsgWizardSymptom || new URLSearchParams(window.location.search).get('symptom');
      if (preselect && SYMPTOMS.find(function (s) { return s.id === preselect; })) {
        state.symptom = preselect;
        state.step = 2;
      }
      render(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  window.TSGWizard = { init: init };
})();
